import React from 'react';
import Logo from 'common/Logo';

const SearchBucketsHeader = (props) => {
    if (props.logoUrl) {
        return (
            <header className="section-header">
                <Logo logoUrl={props.logoUrl} tags={props.tags} className={'section-header_logo'} />
                <h1 className="section-header_title">{props.name}</h1>
            </header>
        );
    }

    return (
        <header className="section-header">
            <h1 className="section-header_title">{props.name}</h1>
        </header>
    );
};

SearchBucketsHeader.propTypes = {
    name: React.PropTypes.string,
    logoUrl: React.PropTypes.string,
    tags: React.PropTypes.array
};

export default SearchBucketsHeader;



// WEBPACK FOOTER //
// ./app/page/search/SearchBucketsHeader.js